import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { KidsDropdown } from './KidsDropdown';
import { ErrorMessage } from '../../PaxSelector';
import { HotelRoomUtils } from '../../../utils';

export const KidSelector = ({ kids, onSelectKidAge, showKidError, isNative, kidsAgeRange }) => {
    const { t } = useTranslation();

    return (
        <>
            <div style={{ flexWrap: 'wrap' }} className="odf-flex-container-row odf-flex-container-gutter-sm odf-space-outer-bottom-m">
                {kids.map((kid, index) => (
                    // safe to use index as key since we are not reordering the list
                    // eslint-disable-next-line react/no-array-index-key
                    <div style={{ maxWidth: '50%', minWidth: '50%' }} className="odf-flex-item" key={index}>
                        <span className="odf-space-inner-bottom-m odf-text-md odf-text-capitalize">
                            {t('paxSelector.children.singular')} {index + 1}
                        </span>
                        <KidsDropdown
                            value={kid}
                            onSelectKidAge={(selectedItem) => onSelectKidAge(index, selectedItem)}
                            showKidError={showKidError}
                            isNative={isNative}
                            kidsAgeRange={kidsAgeRange}
                        />
                    </div>
                ))}
            </div>
            {showKidError && HotelRoomUtils.isKidsAgeInvalid({ kids }) && (
                <ErrorMessage
                    type="odf-text-negative"
                    icon="odf-icon-exclamation-circle"
                    message="roomSelector.children.error"
                />
            )}
        </>
    );
};

KidSelector.propTypes = {
    kids: PropTypes.array.isRequired,
    onSelectKidAge: PropTypes.func.isRequired,
    showKidError: PropTypes.bool.isRequired,
    isNative: PropTypes.bool,
    kidsAgeRange: PropTypes.arrayOf(PropTypes.number)
};

KidSelector.defaultProps = {
    isNative: false,
};
